import type { KnowledgeArticle } from "../types"

export const aiKennisbankVoorBedrijven: KnowledgeArticle = {
  id: "insight:ai-kennisbank-voor-bedrijven",
  pageType: "knowledge-article",
  slug: { nl: "ai-kennisbank-voor-bedrijven" },
  title: {
    nl: "Wat is een AI Kennisbank? | Voor bedrijven: opzetten en bouwen",
    en: "AI Kennisbank voor Bedrijven | Van documentatie naar antwoorden",
  },
  description: {
    nl: "Wat is een AI-kennisbank en hoe zet je er een op? Een AI-kennisbank maakt bedrijfskennis vindbaar via gewone vragen: welke bronnen geschikt zijn en wat het oplevert.",
    en: "An AI knowledge base makes company knowledge findable through plain questions. How do you build one, which sources fit, and what does it deliver?",
  },
  h1: {
    nl: "Wat is een AI-kennisbank? Zo zet je er een op voor je bedrijf",
    en: "Wat is een AI-kennisbank? Zo zet je er een op voor je bedrijf",
  },
  published: "2026-08-26",
  modified: "2026-10-29",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "In vrijwel elk bedrijf ligt kennis verstopt in documenten: handleidingen, procedures, offertes, projectverslagen, FAQ's. De kennis bestaat, maar is niet vindbaar op het moment dat iemand haar nodig heeft. Een AI-kennisbank lost dat op door documentatie conversatie-toegankelijk te maken.",
    },
    {
      type: "heading",
      text: "Wat is een AI-kennisbank?",
    },
    {
      type: "paragraph",
      text: "Een AI-kennisbank combineert zoektechniek met taalmodellen. Medewerkers of klanten stellen een vraag in gewone taal; het systeem zoekt in geïndexeerde bedrijfsdocumentatie de relevante passages en formuleert daaruit een antwoord, idealiter met verwijzing naar de bron. Technisch is dit verwant aan RAG (Retrieval-Augmented Generation): retrieval zorgt dat het juiste gevonden wordt, generatie zorgt dat het begrijpelijk geformuleerd wordt.",
    },
    {
      type: "heading",
      text: "Welke bronnen lenen zich ervoor?",
    },
    {
      type: "list",
      items: [
        "Interne wiki's en handleidingen: de klassieker, direct effectief.",
        "Klantcommunicatie: FAQ-documenten, supportscripts, productinformatie.",
        "Beleidsdocumenten: procedures en regelingen die medewerkers moeten naleven.",
        "Projectkennis: verslagen en architectuurdocumentatie die anders verdwijnen in mappenstructuren.",
      ],
    },
    {
      type: "heading",
      text: "Voor wie binnen de organisatie?",
    },
    {
      type: "paragraph",
      text: "Twee varianten met verschillende eisen. Een klantgerichte kennisbank (zoals de navigatieassistent die we voor Burgerkracht bouwden) moet robuust zijn tegen vreemde formuleringen en mag nooit gevoelige informatie prijsgeven. Een internekennisbank mag dieper in systemen kijken maar vereist authenticatie en rechtenbeheer: niet iedereen mag alles vinden.",
    },
    {
      type: "heading",
      text: "Wat levert het concreet op?",
    },
    {
      type: "paragraph",
      text: "Het primaire effect is tijdteruggave: minder tijd kwijt aan zoeken en aan het herhaaldelijk beantwoorden van dezelfde vragen. Daarnaast verhoogt het de kwaliteit van beslissingen omdat de actuele informatie bereikbaar wordt. Bij Burgerkracht resulteerde de conversatieve aanpak in een platform waar bezoekers relevante groepen en informatie automatisch aangereikt krijgen in plaats van zelf te moeten graven.",
    },
    {
      type: "callout",
      title: "Start klein",
      text: "Begin met de tien vragen die in jouw organisatie het vaakst gesteld worden. Als die perfect beantwoord worden, groeit het vertrouwen — en daarmee het gebruik.",
    },
  ],
  relatedServiceIds: ["ai-knowledge-systems"],
  relatedCaseIds: ["burgerkracht"],
}
